export default "/_next/static/images/reats-2x-d6da8186c67a7f2d2b5c9149cca89d65.jpg";